import { Button, Flex, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { toast } from 'react-toastify';
import api from 'services/api';
import { useEvaluationSelectorStore } from 'stores/evaluationSelector';

const graphs = ['Alinhamento dos valores', 'Alinhamento das necessidades'];

type TTableAlinhamentoSide = (number | string)[][];
type TTableAlinhamento = {
  values: TTableAlinhamentoSide;
  necessities: TTableAlinhamentoSide;
};

const defaultTableAlinhamento: TTableAlinhamento = {
  values: [],
  necessities: [],
};

export default function AlinhamentoChart(): JSX.Element {
  const selectedEv = useEvaluationSelectorStore((state) => state.selectedEvaluations);
  const selectedRep = useEvaluationSelectorStore((state) => state.selectedAlinhamentosEvaluations);
  const [showGraph, setShowGraph] = useState<number>(0);
  const [info, setInfo] = useState<TTableAlinhamento>(defaultTableAlinhamento);

  useEffect(() => {
    setInfo(defaultTableAlinhamento);
    if (!selectedEv[0]?.evaluation_id || !selectedRep[0]?.evaluation_id) return;
    api
      .post(`/tableresponse/evaluations`, { evaluations: [selectedEv[0].evaluation_id, selectedRep[0].evaluation_id] })
      .then(({ data }) => {
        setInfo(data);
      })
      .catch((err) => {
        toast.error('Erro ao buscar dados');
        setInfo(defaultTableAlinhamento);
      });
  }, [selectedEv, selectedRep]);

  const header = document.getElementById('evaluation-header');

  if (
    !selectedEv[0]?.evaluation_id ||
    !selectedRep[0]?.evaluation_id ||
    selectedRep[0]?.evaluation_id === selectedEv[0]?.evaluation_id ||
    info.values.length === 0 ||
    info.necessities.length === 0
  )
    return <></>;

  return (
    <Flex width="100%" height="100%" overflow="auto" justifyContent="center" alignItems="center" gap="2rem">
      {!!header &&
        createPortal(
          <>
            {graphs.map((graph, index) => (
              <Button
                ml={index === 0 ? 'auto' : ''}
                colorScheme={showGraph === index ? 'yellow' : 'blackAlpha'}
                onClick={() => setShowGraph(index)}
                w="max-content"
              >
                {graph}
              </Button>
            ))}
          </>,
          header,
        )}
      <Flex flexDir="column" alignItems="center">
        <Flex
          boxShadow={'#7a7a7a 0rem 0rem 0.0625rem'}
          maxWidth="35rem"
          width="100%"
          borderRadius={'0.3125rem'}
          overflowY="auto"
          maxHeight="min(37.5rem, 100%)"
          marginTop="auto"
          marginBottom="auto"
          style={{ scrollbarWidth: 'thin' }}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              justifyItems: 'center',
              alignItems: 'center',
              textAlign: 'center',
              lineHeight: '1',
              gap: '0',
            }}
          >
            <div
              style={{
                borderTop: '1rem #376090 solid',
                background: `rgba(79, 129, 187, 1)`,
                color: 'white',
                display: 'flex',
                height: '5rem',
                padding: '0.5rem',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                fontWeight: 700,
              }}
            >
              {`${!showGraph ? 'Valores exclusivos' : 'Necessidades exclusivas'} do participante`}
            </div>
            <div
              style={{
                borderTop: '1rem #953736 solid',
                background: `rgba(192, 81, 78, 1)`,
                color: 'white',
                display: 'flex',
                height: '5rem',
                padding: '0.5rem',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                fontWeight: 700,
              }}
            >
              {`${!showGraph ? 'Valores compartilhados' : 'Necessidades compartilhadas'} `}
            </div>
            <div
              style={{
                borderTop: '1rem #779342 solid',
                background: `rgba(155, 187, 95, 1)`,
                color: 'white',
                display: 'flex',
                height: '5rem',
                padding: '0.5rem',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                fontWeight: 700,
              }}
            >
              {`${!showGraph ? 'Valores exclusivos' : 'Necessidades exclusivas'} da empresa`}
            </div>
            {(!showGraph ? info?.values : info?.necessities)?.map((row, index) => (
              <React.Fragment key={index}>
                {row.map((it, c) => (
                  <div
                    key={c}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100%',
                      height: '3.5rem',
                      padding: '0.5rem',
                      textTransform: 'capitalize',
                      fontWeight: 500,
                      background:
                        c === 0
                          ? `rgba(79, 129, 187, ${index % 2 ? 0.3 : 0.1})`
                          : c === 1
                          ? `rgba(192, 81, 78, ${index % 2 ? 0.3 : 0.1})`
                          : `rgba(155, 187, 95, ${index % 2 ? 0.3 : 0.1})`,
                    }}
                  >
                    {it.toString().toLowerCase()}
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
        </Flex>
        <Text fontWeight="800" align="center" marginTop="0.625rem" fontSize="1.25rem">
          ANÁLISE COMPARATIVA <br /> DOS VALORES DO PARTICIPANTE E DA EMPRESA
        </Text>
        {/* <Text
            as="i"
            fontWeight="400"
            align="center"
            marginTop="0.625rem"
            fontSize="0.875rem"
            maxWidth="700"
            color="gray.500"
          >
            As barras representam a média das respostas de todos os respondentes para cada afirmativa.
            <br />A linha tracejada azul indica a média geral das 7 afirmativas.
          </Text> */}
      </Flex>
    </Flex>
  );
}
